export async function stableHashWeb(value: string, _salt?: string): Promise<string> {
  const enc = new TextEncoder();
  const g: any = globalThis as any;
  const salt = (g?.__SENTRY_HASH_SALT__ || (import.meta as any)?.env?.VITE_SENTRY_HASH_SALT || 'local-dev-salt') as string;
  const data = `${salt}:${value}`;
  const subtle: SubtleCrypto | undefined = (globalThis as any)?.crypto?.subtle;
  if (!subtle) {
    let acc = 0;
    for (let i = 0; i < data.length; i++) acc = (acc * 31 + data.charCodeAt(i)) >>> 0;
    return acc.toString(16).padStart(8, '0').repeat(8).slice(0, 64);
  }
  const digest = await subtle.digest('SHA-256', enc.encode(data));
  const bytes = new Uint8Array(digest);
  let out = '';
  for (let i = 0; i < bytes.length; i++) out += bytes[i].toString(16).padStart(2, '0');
  return out;
}


